const adtest = "off";

export default adtest;



// WEBPACK FOOTER //
// ./src/components/ads/adtest.js